var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm._class},[_c('img',{class:_vm.imageClass,attrs:{"src":_vm.src,"height":_vm.height,"width":_vm.width,"loading":_vm.loading}}),_vm._v(" "),_vm._t("bottom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }